import {api} from './Api';

export const getRoles = () => {
  return api.get('/role/').then(res => res.data);
};

export const getRole = (uid: string) => {
  return api.get(`/role/${uid}`).then((res: any) => res.data);
};

export const createRole = (name: string) => {
  const payload = {
    name,
  }

  return api.post('/role/', payload).then((res: any) => res.data);
};

export const updateRole = (uid: string, name: string) => {
  const payload = {
    name,
  }

  return api.put(`role/${uid}`, payload).then((res: any) => res.data);
};

export const deleteRole = (uid: string) => {
  return api.delete(`role/${uid}`).then((res: any) => res.data);
};

export const assignRole = (uid: string, usersUid: string[]) => {
  const payload = {
    users_uid: usersUid,
  }

  return api.post(`role/${uid}/assign_users`, payload).then((res: any) => res.data);
}

export const revokeRole = (uid: string, usersUid: string[]) => {
  const payload = {
    users_uid: usersUid,
  }

  return api.post(`role/${uid}/revoke_users`, payload).then((res: any) => res.data);
}
